import { Component, Prop, Vue } from 'vue-property-decorator'
// eslint-disable-next-line
import ComponentChatx from '../chatx'

@Component({})
export default class ComponentChatxMessage extends Vue {
  @Prop({ default: '' }) text: string
  @Prop({ default: 'message' }) type: 'message' | 'marker'
  @Prop({ default: 'right' }) align: 'left' | 'right' | 'center'
  @Prop({ default: '' }) senderName: string

  @Prop({ default: '' }) attachmentUrl: string
  @Prop({ default: '' }) attachmentName: string
  @Prop({ default: 'any' }) attachmentType: string

  @Prop({ default: false }) showFooter: boolean

  @Prop({ default: '' }) createdAt: string
  @Prop({ default: '' }) groupId: string
  @Prop({ default: '' }) messageContentStyle: string
  @Prop({ default: { showBadge: false, badgeIcon: '', badgeColor: '', badgeText: '' } }) badge: any

  canShowDateMarker = false
  isTheSameGroupThatPreviousMessage = false

  mounted() {
    this.checkCanShowDateMarker()
    this.checkIsTheSameGroupThatPreviousMessage()

    // After verifications inject message component in parent
    const parentComponent = this.$parent as ComponentChatx
    parentComponent.lastComponentMessage = this
  }

  checkIsTheSameGroupThatPreviousMessage() {
    const parentComponent = this.$parent as ComponentChatx
    const { lastComponentMessage } = parentComponent

    if (
      lastComponentMessage
      && lastComponentMessage.groupId
      && lastComponentMessage.groupId === this.groupId
      && lastComponentMessage.type !== 'marker'
    ) {
      this.isTheSameGroupThatPreviousMessage = true
    }
  }

  checkCanShowDateMarker() {
    const parentComponent = this.$parent as ComponentChatx
    const { lastComponentMessage } = parentComponent

    if (this.createdAt && lastComponentMessage && lastComponentMessage.createdAt) {
      const previousMessageCreatedAt = new Date(lastComponentMessage.createdAt)
      const createdAt = new Date(this.createdAt)

      previousMessageCreatedAt.setHours(0, 0, 0, 0)
      createdAt.setHours(0, 0, 0, 0)

      if (previousMessageCreatedAt.getTime() !== createdAt.getTime()) {
        this.canShowDateMarker = true
      }
    } else if (this.createdAt && !lastComponentMessage) {
      this.canShowDateMarker = true
    }
  }

  formatCreatedAtForDayMarker(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)

      let completedDate: string
      if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
        completedDate = 'Hoje'
      } else {
        completedDate = date.toLocaleDateString()
      }

      return `${completedDate}`
    }

    return ''
  }

  formatCreatedAtForFooter(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${hours}:${minutes}`
    }

    return ''
  }

  formatCreatedAtForHeader(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${hours}:${minutes}`
    }

    return ''
  }

  get containerClasses() {
    const classes: string[] = []

    if (this.isTheSameGroupThatPreviousMessage && this.type !== 'marker') {
      classes.push('-same-group')
    }

    return classes
  }

  get wrapClasses() {
    const classes: string[] = []

    if (this.align === 'left') {
      classes.push('-align-left')
    } else if (this.align === 'right') {
      classes.push('-align-right')
    } else if (this.align === 'center') {
      classes.push('-align-center')
    }

    if (this.canShowAsMarker) {
      classes.push('-marker')
    }

    if (this.canShowDateMarker) {
      classes.push('-has-date-marker')
    }

    return classes
  }

  get read() {
    const parentComponent = this.$parent as ComponentChatx

    if (parentComponent.recipientOnline) {
      return true
    }

    if (parentComponent.recipientLastSeenDate && this.createdAt) {
      const recipientLastSeenDate = new Date(parentComponent.recipientLastSeenDate)
      const createdAt = new Date(this.createdAt)

      return recipientLastSeenDate.getTime() >= createdAt.getTime()
    }

    return false
  }

  // Permissions

  get canShowHeader() {
    return this.senderName
  }

  get canShowFooter() {
    return this.showFooter
  }

  get canShowAsMarker() {
    return this.type === 'marker'
  }
}
